<script>
import { mapGetters } from 'vuex'
import { API } from '@lib/processors/api-processor'
import HeaderPublish from './components/publish/publish-changes'
import Vue from 'vue'

export default {
  name: 'SuperApp',
  components: {
    HeaderPublish,
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'loggedIn',
    ]),
    ...mapGetters('ui', [
      'menu',
    ]),
    isServiceRoute() {
      const serviceRoutes = ['login', 'logout', 'callback', 'forbidden', '404']
      const { name } = this.$route

      return serviceRoutes.indexOf(name) !== -1
    },
    showRouterView() {
      return this.isServiceRoute || this.loaded
    },
  },
  created() {
    if (this.loggedIn) {
      this.loaded = true
    }
  },
  methods: {
    async handleLoginEvent(data) {
      const authHeader = `Bearer ${data.accessToken}`
      const { dispatch } = this.$store

      Vue.prototype.$accessToken = data.accessToken
      API.defaults.headers.common['Authorization'] = authHeader

      await Promise.all([
        dispatch('catalogues/getCatalogues'),
        dispatch('feeds/getFeedUpdates'),
        dispatch('categories/getCategories'),
      ])

      window.gtag('set', {
        user_id: data.decodedToken['https://eonx.com/user'].id,
      })

      this.$store.dispatch('me/getMe')

      this.loaded = true
    },
  },
}
</script>

<template>
  <app-layout
    id="app"
    :menu="menu"
    title="Online Offers"
  >
    <base-loader
      v-if="!showRouterView"
      transparent
      fullscreen
    />
    <template v-else>
      <header-publish slot="header-right" />
      <router-view />
    </template>
  </app-layout>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">

#nprogress .bar {
  background: var(--color-link);
}

.el-notification__content {
  text-align: left;
}

</style>
